var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.hasValue)?_c('span',[_vm._v("\n    "+_vm._s(_vm.formattedValue)+"\n  ")]):_c('span',{staticClass:"font-italic"},[_vm._v(" No value ")])])}
var staticRenderFns = []

export { render, staticRenderFns }